import React, { useState, useEffect } from 'react';
import { 
  Typography, 
  Slider, 
  TextField,
  Button, 
  Card, 
  CardContent,
  Grid,
  Box,
  Paper,
  Link,
  InputAdornment
} from '@mui/material';

const PricingCalculator = () => {
  const [bcbas, setBcbas] = useState(10);
  const [pricePerBCBA, setPricePerBCBA] = useState(50);
  const [monthlyTotal, setMonthlyTotal] = useState(0);
  const [annualTotal, setAnnualTotal] = useState(0);
  const [discountedAnnual, setDiscountedAnnual] = useState(0);

  useEffect(() => {
    const calculatedMonthly = bcbas * pricePerBCBA;
    setMonthlyTotal(calculatedMonthly);
    setAnnualTotal(calculatedMonthly * 12);
    setDiscountedAnnual(calculatedMonthly * 12 * 0.8); // 20% discount
  }, [bcbas, pricePerBCBA]);

  const handleNumberInput = (setter) => (event) => {
    let value = event.target.value.replace(/^0+/, '');
    if (value === '') {
      setter(0);
      event.target.value = '0';
    } else {
      const number = Number(value);
      if (!isNaN(number)) {
        setter(number);
        event.target.value = number.toString();
      }
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 3, backgroundColor: 'background.default' }}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Card elevation={2}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Number of BCBAs
              </Typography>
              <Slider
                value={bcbas}
                onChange={(_, newValue) => setBcbas(newValue)}
                min={1}
                max={200}
                valueLabelDisplay="auto"
              />
              <Typography variant="body1" align="center">
                {bcbas}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card elevation={2}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Price per BCBA
              </Typography>
              <TextField
                type="text"
                value={pricePerBCBA}
                onChange={handleNumberInput(setPricePerBCBA)}
                fullWidth
                InputProps={{
                  startAdornment: <InputAdornment position="start">$</InputAdornment>,
                }}
                inputProps={{ 
                  inputMode: 'numeric', 
                  pattern: '[0-9]*',
                  min: 25,
                  max: 75
                }}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Card elevation={2} sx={{ mt: 4 }}>
        <CardContent>
          <Typography variant="h5" gutterBottom align="center">
            Pricing Summary
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Typography variant="h6" gutterBottom align="center">
                Monthly Cost
              </Typography>
              <Typography variant="h4" color="primary" align="center">
                ${monthlyTotal.toLocaleString(undefined, { maximumFractionDigits: 0 })}
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="h6" gutterBottom align="center">
                Annual Cost
              </Typography>
              <Typography variant="h4" color="secondary" align="center">
                ${annualTotal.toLocaleString(undefined, { maximumFractionDigits: 0 })}
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="h6" gutterBottom align="center">
                Annual Contract (20% Discount)
              </Typography>
              <Typography variant="h4" color="success.main" align="center">
                ${discountedAnnual.toLocaleString(undefined, { maximumFractionDigits: 0 })}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Box sx={{ mt: 3, textAlign: 'center' }}>
        <Button 
          variant="contained" 
          color="primary" 
          size="large"
          component={Link}
          href="https://www.joonhealth.co/company/demo-aba"
          target="_blank"
          rel="noopener noreferrer"
        >
          Schedule a free demo
        </Button>
      </Box>
    </Paper>
  );
};

export default PricingCalculator;